export default "__VITE_ASSET__b2d4f2df__"